var _path, _g, _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.dev/svgjs",
    width: 2000,
    height: 1250,
    viewBox: "0 0 2000 1250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 320",
    "data-background-color": "#ff5858",
    preserveAspectRatio: "xMidYMid meet",
    height: 1250,
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 320",
    height: 320,
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 320",
    height: 320,
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96 320l0-320 320 0 0 320zM407.081 311.081l0-302.162-302.162 0 0 302.162z",
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,148.73504273504273,80)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.52991452991452 160",
    height: 160,
    width: 214.52991452991452,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 214.52991452991452,
    viewBox: "0.78 -22.78 30.64 22.85",
    height: 160,
    "data-palette-color": "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74 0.07Q6.57 0.07 6.32-0.83L6.32-0.83 0.88-21Q0.78-21.29 0.78-21.66L0.78-21.66Q0.78-22.78 3.49-22.78L3.49-22.78Q5.25-22.78 6.02-22.57 6.79-22.36 6.91-21.88L6.91-21.88 9.86-10.42Q9.96-10.08 10.11-9.4L10.11-9.4 10.33-8.5Q10.6-9.59 10.86-10.55L10.86-10.55 13.62-21.88Q13.79-22.78 16.04-22.78L16.04-22.78 17.07-22.78Q18.04-22.78 18.7-22.55 19.36-22.31 19.46-21.88L19.46-21.88 22.24-10.28Q22.27-10.08 22.44-9.5L22.44-9.5 22.66-8.5 23.17-10.42 26.17-21.88Q26.46-22.78 28.74-22.78L28.74-22.78Q31.42-22.78 31.42-21.66L31.42-21.66Q31.42-21.58 31.32-21L31.32-21 26.22-0.83Q26.1-0.39 25.44-0.16 24.78 0.07 23.83 0.07L23.83 0.07 21.7 0.07Q19.56 0.07 19.34-0.83L19.34-0.83 16.67-11.16Q16.5-11.77 16.21-13.04L16.21-13.04 15.7-11.11 13.23-0.83Q13.13-0.39 12.48-0.16 11.82 0.07 10.86 0.07L10.86 0.07 8.74 0.07Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 320,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f636201f285f9c3ba99def1a9f5e918b.svg";
export { ForwardRef as ReactComponent };